import { database } from "./FirebaseConfig";
import { ref, get } from 'firebase/database';

///bio, experience, education, timeLine, skill, project

// Fetches the entire database in a SINGLE read, instead of one read per
// section. Returns { bio, experience, education, timeLine, skill, project }.
// Use this (via PortfolioDataContext) instead of the individual fetch*
// functions below whenever you need more than one section, which in
// practice is every page load.
export const fetchAllData = async () => {
  try {
    const rootRef = ref(database, '/');
    const snapshot = await get(rootRef);
    const data = snapshot.val();
    if (!data) {
      throw new Error("No data found in the database.");
    }
    return data;
  } catch (error) {
    console.error("Error fetching portfolio data:", error.message);
    throw new Error(`Failed to fetch portfolio data. Please try again later. Additional error details: ${error.message}`);
  }
};

// ---------------------------------------------------------------------
// Individual section fetchers. Kept for any one-off/admin use cases,
// but components should prefer usePortfolioData() (single call above)
// rather than calling these directly, to avoid N separate Firebase reads.
// ---------------------------------------------------------------------

export const fetchBioData = async () => {
  try {
    const bioRef = ref(database, 'bio');
    const snapshot = await get(bioRef);
    const data = snapshot.val();
    if (!data) {
      throw new Error("No data found in the database.");
    }
    return data;
  } catch (error) {
    console.error("Error fetching bio data:", error.message);
    throw new Error(`Failed to fetch bio data. Please try again later. Additional error details: ${error.message}`);
  }
};

export const fetchExperienceData = async () => {
  try {
    const reference = ref(database, 'experience');
    const snapshot = await get(reference);
    const data = snapshot.val();
    if (!data) {
      throw new Error("No data found in the database.");
    }
    return data;
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw new Error(`Failed to fetch data. Please try again later. Additional error details: ${error.message}`);
  }
};

export const fetchEducationData = async () => {
  try {
    const reference = ref(database, 'education');
    const snapshot = await get(reference);
    const data = snapshot.val();
    if (!data) {
      throw new Error("No data found in the database.");
    }
    return data;
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw new Error(`Failed to fetch data. Please try again later. Additional error details: ${error.message}`);
  }
};

export const fetchTimelineData = async () => {
  try {
    const reference = ref(database, 'timeLine');
    const snapshot = await get(reference);
    const data = snapshot.val();
    if (!data) {
      throw new Error("No data found in the database.");
    }
    return data;
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw new Error(`Failed to fetch data. Please try again later. Additional error details: ${error.message}`);
  }
};

export const fetchSkillData = async () => {
  try {
    const reference = ref(database, 'skill');
    const snapshot = await get(reference);
    const data = snapshot.val();
    if (!data) {
      throw new Error("No data found in the database.");
    }
    return data;
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw new Error(`Failed to fetch data. Please try again later. Additional error details: ${error.message}`);
  }
};

export const fetchProjectData = async () => {
  try {
    const reference = ref(database, 'project');
    const snapshot = await get(reference);
    const data = snapshot.val();
    if (!data) {
      throw new Error("No data found in the database.");
    }
    return data;
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw new Error(`Failed to fetch data. Please try again later. Additional error details: ${error.message}`);
  }
};
